import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslate } from '../../../Helper/GetTranslate';

export class ComparasionChart extends Component {
    render() {

         const translate = getTranslate().partners.comparasion;
        return (
            <>
                <section className="pricing">
                    <div className="container">
                        <div className="section-title text-center">
                        <h3 className="sub-title wow pixFadeUp">{translate.pre_title}</h3>
                            <h2 className="title wow pixFadeUp" data-wow-delay="0.3s"
                                dangerouslySetInnerHTML={{ __html: translate.title }}
                            >

                            </h2>
                        </div>

                        <div className="row advanced-pricing-table no-gutters wow pixFadeUp" data-wow-delay="0.5s">


                            <div className="col-lg-6">
                                <div className="pricing-table color-two">
                                    <div className="pricing-header pricing-amount">
                                        <h3 className="price-title">{translate.left.title}</h3>

                                    </div>


                                    <ul className="price-feture">
                                        <li className="not">{translate.left.row1}</li>
                                        <li className="not">{translate.left.row2}</li>
                                        <li className="not">{translate.left.row3}</li>
                                        <li className="not">{translate.left.row4}</li>
                                        <li className="not">{translate.left.row5}</li>
                                        <li className="not">{translate.left.row6}</li>
                                        <li className="not">{translate.left.row7}</li>
                                        <li className="not">{translate.left.row8}</li>
                                        <li className="not">{translate.left.row9}</li>
                                        <li className="not">{translate.left.row10}</li>
                                        <li className="not">{translate.left.row11}</li>
                                      
                                    </ul>

                                </div>

                            </div>


                            <div className="col-lg-6">
                                <div className="pricing-table color-three" style={{ borderRight: 0 }}>

                                    <div className="pricing-header pricing-amount">
                                        <h3 className="price-title">{translate.right.title}</h3>

                                    </div>


                                    <ul className="price-feture">
                                        <li className="have">{translate.right.row1}</li>
                                        <li className="have">{translate.right.row2}</li>
                                        <li className="have">{translate.right.row3}</li>
                                        <li className="have">{translate.right.row4}</li>
                                        <li className="have">{translate.right.row5}</li>
                                        <li className="have">{translate.right.row6}</li>
                                        <li className="have">{translate.right.row7}</li>
                                        <li className="have">{translate.right.row8}</li>
                                        <li className="have">{translate.right.row9}</li>
                                        <li className="have">{translate.right.row10}</li>
                                        <li className="have">{translate.right.row11}</li>
                                      
                                    </ul>

                                </div>

                            </div>

                        </div>

                    </div>
                </section>

                <section className="call-to-action">

                <div className="container">
                        <div className="action-content text-center wow pixFadeUp">
                            <h2 className="title" dangerouslySetInnerHTML={{__html:translate.banner.title}}>
                                
                            </h2>

                            <p dangerouslySetInnerHTML={{__html:translate.banner.text}}>
                            </p>

                            <a href="https://partners.tourzone.com" rel="noreferrer" target="_blank" className="pix-btn btn-light">{translate.banner.button}</a>
                        </div>

                    </div>




                </section>
            </>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(ComparasionChart)